import { t, d, y, u, G } from "main/jsxRuntime.module";
import { u as useMembership } from "main/useMembership";
import "main/membership-service";
var _jsxFileName$1 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/CartMembershipUpsell.tsx";
const COLOR_SCHEMES = {
  blue: {
    background: "rs-bg-[#0069E4]",
    button: "rs-bg-black rs-text-white hover:rs-bg-gray-900",
    text: "rs-text-white"
  },
  purple: {
    background: "rs-bg-[#7247FF]",
    button: "rs-bg-black rs-text-white hover:rs-bg-gray-900",
    text: "rs-text-white"
  },
  green: {
    background: "rs-bg-[#019D2B]",
    button: "rs-bg-black rs-text-white hover:rs-bg-gray-900",
    text: "rs-text-white"
  }
};
function CartMembershipUpsell({
  "blocks": blocksJson = "[]",
  "class": className = "",
  "blue-texture-desktop": blueTextureDesktop = "",
  "blue-texture-mobile": blueTextureMobile = "",
  "green-texture-desktop": greenTextureDesktop = "",
  "green-texture-mobile": greenTextureMobile = "",
  "purple-texture-desktop": purpleTextureDesktop = "",
  "purple-texture-mobile": purpleTextureMobile = ""
}) {
  const getTextureUrls = (colorScheme) => {
    const textureMap = {
      blue: {
        desktop: blueTextureDesktop,
        mobile: blueTextureMobile
      },
      green: {
        desktop: greenTextureDesktop,
        mobile: greenTextureMobile
      },
      purple: {
        desktop: purpleTextureDesktop,
        mobile: purpleTextureMobile
      }
    };
    const result = textureMap[colorScheme] || {
      desktop: "",
      mobile: ""
    };
    return result;
  };
  const [cart, setCart] = t(d(null), "cart");
  const [productData, setProductData] = t(d({}), "productData");
  const {
    membershipStatus,
    memberships,
    customerId,
    isLoading: membershipLoading
  } = useMembership();
  y(() => {
    console.log("membershipStatus", membershipStatus);
    console.log("memberships", memberships);
    console.log("customerId", customerId);
  }, [membershipStatus, memberships, customerId]);
  const rawBlocks = JSON.parse(blocksJson);
  const blocks = rawBlocks.map((blockSettings) => ({
    id: Date.now().toString() + Math.random(),
    // Generate unique ID
    type: "membership-upsell",
    settings: {
      ...blockSettings,
      products_to_add: typeof blockSettings.products_to_add === "string" ? blockSettings.products_to_add.split(",").map((id) => id.trim()).filter(Boolean) : blockSettings.products_to_add || [],
      required_products: typeof blockSettings.required_products === "string" ? blockSettings.required_products.split(",").map((id) => id.trim()).filter(Boolean) : blockSettings.required_products || [],
      required_subscription_frequencies: typeof blockSettings.required_subscription_frequencies === "string" ? blockSettings.required_subscription_frequencies.split(",").map((freq) => freq.trim().toLowerCase()).filter(Boolean) : blockSettings.required_subscription_frequencies || [],
      required_tags: typeof blockSettings.required_tags === "string" ? blockSettings.required_tags.split(",").map((tag) => tag.trim().toLowerCase()).filter(Boolean) : blockSettings.required_tags || [],
      // Parse hide condition arrays
      hide_required_products: typeof blockSettings.hide_required_products === "string" ? blockSettings.hide_required_products.split(",").map((id) => id.trim()).filter(Boolean) : blockSettings.hide_required_products || [],
      hide_required_subscription_frequencies: typeof blockSettings.hide_required_subscription_frequencies === "string" ? blockSettings.hide_required_subscription_frequencies.split(",").map((freq) => freq.trim().toLowerCase()).filter(Boolean) : blockSettings.hide_required_subscription_frequencies || [],
      hide_required_tags: typeof blockSettings.hide_required_tags === "string" ? blockSettings.hide_required_tags.split(",").map((tag) => tag.trim().toLowerCase()).filter(Boolean) : blockSettings.hide_required_tags || [],
      // Default to 'and' logic for backwards compatibility
      show_conditions_logic: blockSettings.show_conditions_logic || "and",
      hide_conditions_logic: blockSettings.hide_conditions_logic || "and"
    }
  }));
  const fetchProductDataByHandle = async (handle) => {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        console.warn(`CartMembershipUpsell: Failed to fetch product ${handle}:`, response.status);
        return null;
      }
      const product = await response.json();
      return {
        id: product.id,
        handle: product.handle,
        tags: product.tags || [],
        title: product.title
      };
    } catch (error) {
      console.error(`CartMembershipUpsell: Error fetching product ${handle}:`, error);
      return null;
    }
  };
  const fetchCartProductData = async (cartItems) => {
    const productHandles = {};
    cartItems.forEach((item) => {
      if (item == null ? void 0 : item.handle) {
        productHandles[item.product_id] = item == null ? void 0 : item.handle;
      }
    });
    const productIds = Array.from(new Set(cartItems.map((item) => item.product_id)));
    setProductData((currentProductData) => {
      const missingProductIds = productIds.filter((id) => !currentProductData[id]);
      if (missingProductIds.length === 0) {
        return currentProductData;
      }
      const missingProductsWithHandles = missingProductIds.filter((id) => productHandles[id]).map((id) => ({
        id,
        handle: productHandles[id]
      }));
      if (missingProductsWithHandles.length === 0) {
        return currentProductData;
      }
      Promise.all(missingProductsWithHandles.map(({
        handle
      }) => fetchProductDataByHandle(handle))).then((fetchedProducts) => {
        setProductData((prevData) => {
          const newProductData = {
            ...prevData
          };
          fetchedProducts.forEach((product, index) => {
            if (product) {
              newProductData[product.id] = product;
            }
          });
          return newProductData;
        });
      }).catch((error) => {
        console.error("CartMembershipUpsell: Error fetching product data:", error);
      });
      return currentProductData;
    });
  };
  y(() => {
    const fetchCart = async () => {
      try {
        const response = await fetch("/cart.js");
        if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
        const cartData = await response.json();
        if (cartData && Array.isArray(cartData.items)) {
          setCart(cartData);
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
        setCart(null);
      }
    };
    fetchCart();
    const handleCartRefresh = () => fetchCart();
    document.addEventListener("theme:cart:refresh", handleCartRefresh);
    document.addEventListener("theme:cart:change", handleCartRefresh);
    window.addEventListener("cart:updated", handleCartRefresh);
    return () => {
      document.removeEventListener("theme:cart:refresh", handleCartRefresh);
      document.removeEventListener("theme:cart:change", handleCartRefresh);
      window.removeEventListener("cart:updated", handleCartRefresh);
    };
  }, []);
  y(() => {
    if (cart && cart.items.length > 0) {
      fetchCartProductData(cart.items);
    }
  }, [cart]);
  const getDetailedMembershipStatus = () => {
    if (!customerId) return "not_logged_in";
    if (membershipStatus === "not-member") return "not_member";
    const activeMembership = memberships[0];
    if (!activeMembership) return "not_member";
    const name = activeMembership.name.toLowerCase().replace(/\s+/g, "_");
    const frequency = activeMembership.selectedPlanOption.toLowerCase();
    return `${name}_${frequency}`;
  };
  const checkMembershipCondition = (block) => {
    const status = getDetailedMembershipStatus();
    const conditions = {
      "not_logged_in": block.settings.show_for_not_logged_in,
      "not_member": block.settings.show_for_not_logged_in,
      // Treat same as not logged in
      "af_media_monthly": block.settings.show_for_media_monthly,
      "af_media_quarterly": block.settings.show_for_media_quarterly,
      "af_media_annually": block.settings.show_for_media_annually,
      "af+_monthly": block.settings.show_for_all_access_monthly,
      "af+_quarterly": block.settings.show_for_all_access_quarterly,
      "af+_annually": block.settings.show_for_all_access_annually,
      "support_monthly": block.settings.show_for_support_monthly,
      "support_quarterly": block.settings.show_for_support_quarterly,
      "support_annually": block.settings.show_for_support_annually
    };
    const result = conditions[status] || false;
    return result;
  };
  const checkCartCondition = (block) => {
    if (!cart) {
      return false;
    }
    if (cart.items.length === 0) {
      const result = block.settings.show_for_empty_cart;
      return result;
    }
    const enabledConditions = [];
    if (block.settings.show_for_specific_products && block.settings.required_products.length > 0) {
      const hasRequiredProducts = block.settings.required_products.some((productId) => cart.items.some((item) => item.variant_id.toString() === productId || item.product_id.toString() === productId));
      enabledConditions.push({
        name: "specific_products",
        met: hasRequiredProducts
      });
    }
    if (block.settings.show_for_subscription_products && block.settings.required_subscription_frequencies.length > 0) {
      const hasSubscriptions = cart.items.some((item) => item.selling_plan_allocation && block.settings.required_subscription_frequencies.includes(item.selling_plan_allocation.selling_plan.name.toLowerCase()));
      enabledConditions.push({
        name: "subscription_products",
        met: hasSubscriptions
      });
    }
    if (block.settings.show_for_tagged_products && block.settings.required_tags.length > 0) {
      const hasTaggedProducts = cart.items.some((item) => {
        const product = productData[item.product_id];
        if (!product || !product.tags) return false;
        return product.tags.some((tag) => block.settings.required_tags.includes(tag.toLowerCase()));
      });
      enabledConditions.push({
        name: "tagged_products",
        met: hasTaggedProducts
      });
    }
    if (block.settings.show_for_selling_plan_ids && block.settings.required_selling_plan_ids.length > 0) {
      const hasSellingPlanIds = cart.items.some((item) => item.selling_plan_allocation && block.settings.required_selling_plan_ids.includes(item.selling_plan_allocation.selling_plan.id.toString()));
      enabledConditions.push({
        name: "selling_plan_ids",
        met: hasSellingPlanIds
      });
    }
    if (block.settings.show_for_regular_products) {
      const hasRegularProducts = cart.items.some((item) => {
        const product = productData[item.product_id];
        const hasNoSellingPlan = !item.selling_plan_allocation;
        const isNotMembersOnly = !product || !product.tags || !product.tags.some((tag) => tag.toLowerCase() === "members-only-product");
        const isNotMagazine = !product || !product.tags || !product.tags.some((tag) => tag.toLowerCase() === "magazine");
        return hasNoSellingPlan && isNotMembersOnly && isNotMagazine;
      });
      enabledConditions.push({
        name: "regular_products",
        met: hasRegularProducts
      });
    }
    let cartConditionMet = true;
    if (enabledConditions.length > 0) {
      if (block.settings.show_conditions_logic === "or") {
        cartConditionMet = enabledConditions.some((condition) => condition.met);
      } else {
        cartConditionMet = enabledConditions.every((condition) => condition.met);
      }
    }
    const onlyEmptyCartConditionEnabled = block.settings.show_for_empty_cart && !block.settings.show_for_specific_products && !block.settings.show_for_subscription_products && !block.settings.show_for_tagged_products && !block.settings.show_for_selling_plan_ids;
    if (onlyEmptyCartConditionEnabled) {
      return false;
    }
    const hasCartConditions = block.settings.show_for_specific_products || block.settings.show_for_subscription_products || block.settings.show_for_tagged_products || block.settings.show_for_selling_plan_ids || block.settings.show_for_regular_products;
    const finalResult = hasCartConditions ? cartConditionMet : true;
    return finalResult;
  };
  const checkMembershipHideCondition = (block) => {
    const status = getDetailedMembershipStatus();
    const hideConditions = {
      "not_logged_in": block.settings.hide_for_not_logged_in,
      "not_member": block.settings.hide_for_not_logged_in,
      // Treat same as not logged in
      "af_media_monthly": block.settings.hide_for_media_monthly,
      "af_media_quarterly": block.settings.hide_for_media_quarterly,
      "af_media_annually": block.settings.hide_for_media_annually,
      "af+_monthly": block.settings.hide_for_all_access_monthly,
      "af+_quarterly": block.settings.hide_for_all_access_quarterly,
      "af+_annually": block.settings.hide_for_all_access_annually,
      "af_support_monthly": block.settings.hide_for_support_monthly,
      "af_support_quarterly": block.settings.hide_for_support_quarterly,
      "af_support_annually": block.settings.hide_for_support_annually
    };
    const shouldHide = hideConditions[status] || false;
    return shouldHide;
  };
  const checkCartHideCondition = (block) => {
    if (!cart) {
      return false;
    }
    if (cart.items.length === 0) {
      const shouldHide2 = block.settings.hide_for_empty_cart;
      return shouldHide2;
    }
    const enabledHideConditions = [];
    if (block.settings.hide_for_specific_products && block.settings.hide_required_products.length > 0) {
      const hasHideProducts = block.settings.hide_required_products.some((productId) => cart.items.some((item) => item.variant_id.toString() === productId || item.product_id.toString() === productId));
      enabledHideConditions.push({
        name: "hide_specific_products",
        met: hasHideProducts
      });
    }
    if (block.settings.hide_for_subscription_products && block.settings.hide_required_subscription_frequencies.length > 0) {
      const hasHideSubscriptions = cart.items.some((item) => item.selling_plan_allocation && block.settings.hide_required_subscription_frequencies.includes(item.selling_plan_allocation.selling_plan.name.toLowerCase()));
      enabledHideConditions.push({
        name: "hide_subscription_products",
        met: hasHideSubscriptions
      });
    }
    if (block.settings.hide_for_tagged_products && block.settings.hide_required_tags.length > 0) {
      const hasHideTaggedProducts = cart.items.some((item) => {
        const product = productData[item.product_id];
        if (!product || !product.tags) return false;
        return product.tags.some((tag) => block.settings.hide_required_tags.includes(tag.toLowerCase()));
      });
      enabledHideConditions.push({
        name: "hide_tagged_products",
        met: hasHideTaggedProducts
      });
    }
    if (block.settings.hide_for_selling_plan_ids && block.settings.hide_required_selling_plan_ids.length > 0) {
      const hasHideSellingPlanIds = cart.items.some((item) => item.selling_plan_allocation && block.settings.hide_required_selling_plan_ids.includes(item.selling_plan_allocation.selling_plan.id.toString()));
      enabledHideConditions.push({
        name: "hide_selling_plan_ids",
        met: hasHideSellingPlanIds
      });
    }
    if (block.settings.hide_for_regular_products) {
      const hasHideRegularProducts = cart.items.some((item) => {
        const product = productData[item.product_id];
        const hasNoSellingPlan = !item.selling_plan_allocation;
        const isNotMembersOnly = !product || !product.tags || !product.tags.some((tag) => tag.toLowerCase() === "members-only-product");
        const isNotMagazine = !product || !product.tags || !product.tags.some((tag) => tag.toLowerCase() === "magazine");
        return hasNoSellingPlan && isNotMembersOnly && isNotMagazine;
      });
      enabledHideConditions.push({
        name: "hide_regular_products",
        met: hasHideRegularProducts
      });
    }
    let cartHideConditionMet = false;
    if (enabledHideConditions.length > 0) {
      if (block.settings.hide_conditions_logic === "or") {
        cartHideConditionMet = enabledHideConditions.some((condition) => condition.met);
      } else {
        cartHideConditionMet = enabledHideConditions.every((condition) => condition.met);
      }
    }
    const hasCartHideConditions = block.settings.hide_for_empty_cart || block.settings.hide_for_specific_products || block.settings.hide_for_subscription_products || block.settings.hide_for_tagged_products || block.settings.hide_for_selling_plan_ids || block.settings.hide_for_regular_products;
    const shouldHide = hasCartHideConditions ? cartHideConditionMet : false;
    return shouldHide;
  };
  const getVisibleBlocks = () => {
    return blocks.filter((block) => {
      const membershipMatch = checkMembershipCondition(block);
      const cartMatch = checkCartCondition(block);
      const membershipHideMatch = checkMembershipHideCondition(block);
      const cartHideMatch = checkCartHideCondition(block);
      const shouldDisplay = membershipMatch && cartMatch;
      const shouldHide = membershipHideMatch || cartHideMatch;
      const visible = shouldDisplay && !shouldHide;
      return visible;
    });
  };
  const handleAddProducts = async (productIds, sellingPlanId) => {
    var _a, _b;
    try {
      const items = productIds.map((id) => {
        const item = {
          id,
          quantity: 1
        };
        if (sellingPlanId && sellingPlanId.trim()) {
          item.selling_plan = sellingPlanId.trim();
        }
        return item;
      });
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });
      if (response.ok) {
        if ((_b = (_a = window.Shopify) == null ? void 0 : _a.cart) == null ? void 0 : _b.refreshCart) {
          await window.Shopify.cart.refreshCart();
        } else {
          document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent("theme:cart:change", {
            bubbles: true
          }));
        }
      } else {
        console.error("CartMembershipUpsell: Failed to add products, response:", response.status);
      }
    } catch (error) {
      console.error("Error adding products to cart:", error);
    }
  };
  if (membershipLoading) {
    return null;
  }
  const visibleBlocks = getVisibleBlocks();
  if (visibleBlocks.length === 0) {
    return null;
  }
  return u("div", {
    className: `cart-membership-upsell rs-space-y-4 rs-px-[15px] rs-py-2.5 ${className}`,
    children: visibleBlocks.map((block) => {
      const colorScheme = COLOR_SCHEMES[block.settings.color_scheme];
      const textureUrls = getTextureUrls(block.settings.color_scheme);
      return u("div", {
        children: [textureUrls.desktop && u("div", {
          className: "rs-top-0 rs-left-0 rs-right-0 rs-h-[45px] rs-overflow-hidden rs-z-0 rs-hidden md:rs-block",
          style: {
            backgroundImage: `url(${textureUrls.desktop})`,
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
          }
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 695,
          columnNumber: 13
        }, this), textureUrls.mobile && u("div", {
          className: "rs-top-0 rs-left-0 rs-right-0 rs-h-[45px] rs-overflow-hidden rs-z-0 rs-block md:rs-hidden",
          style: {
            backgroundImage: `url(${textureUrls.mobile})`,
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%"
          }
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 707,
          columnNumber: 13
        }, this), u("div", {
          className: `rs-rounded-br-md rs-rounded-bl-md rs-relative rs-px-4 rs-pb-4  rs-overflow-hidden ${colorScheme.background}`,
          children: u("div", {
            className: "rs-relative rs-z-10",
            children: [u("div", {
              className: "rs-flex rs-items-start rs-justify-between rs-gap-4",
              children: [u("div", {
                className: "rs-flex-1",
                children: [u("h3", {
                  className: `rs-text-[20px] rs-font-bold !rs-leading-none rs-mb-2 ${colorScheme.text}`,
                  children: block.settings.title
                }, void 0, false, {
                  fileName: _jsxFileName$1,
                  lineNumber: 724,
                  columnNumber: 19
                }, this), u("p", {
                  className: `rs-font-tertiary rs-text-base !rs-leading-none ${colorScheme.text} rs-opacity-90`,
                  children: block.settings.description
                }, void 0, false, {
                  fileName: _jsxFileName$1,
                  lineNumber: 727,
                  columnNumber: 19
                }, this), block.settings.learn_more_link && u("a", {
                  href: block.settings.learn_more_link,
                  target: "_blank",
                  className: `rs-text-sm rs-mt-2 rs-underline ${colorScheme.text} rs-opacity-80 hover:rs-opacity-100`,
                  children: block.settings.learn_more_text || "Learn More"
                }, void 0, false, {
                  fileName: _jsxFileName$1,
                  lineNumber: 731,
                  columnNumber: 21
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$1,
                lineNumber: 723,
                columnNumber: 17
              }, this), u("div", {
                className: "rs-flex-shrink-0",
                children: u("svg", {
                  width: "46",
                  height: "44",
                  viewBox: "0 0 46 44",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [u("g", {
                    "clip-path": "url(#clip0_13982_689823)",
                    children: [u("path", {
                      d: "M23 44C35.7025 44 46 34.1503 46 22C46 9.84974 35.7025 0 23 0C10.2975 0 0 9.84974 0 22C0 34.1503 10.2975 44 23 44Z",
                      fill: "black"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 745,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M24.9263 5.54106C24.6025 5.50806 24.3192 5.40611 24.0764 5.2352C23.8351 5.06446 23.6549 4.8357 23.5357 4.54892C23.4182 4.26231 23.3807 3.92844 23.4232 3.54732C23.4658 3.1646 23.5761 2.845 23.7542 2.58851C23.934 2.3306 24.1607 2.1425 24.434 2.02422C24.7092 1.90611 25.0086 1.86356 25.3323 1.89655C25.6577 1.92972 25.9402 2.03158 26.1798 2.20215C26.4193 2.37272 26.5986 2.6022 26.7176 2.89057C26.8367 3.17734 26.8751 3.51209 26.8324 3.89481C26.79 4.27593 26.6789 4.59465 26.4992 4.85098C26.3196 5.1073 26.0938 5.29468 25.8221 5.41314C25.5503 5.53158 25.2517 5.57423 24.9263 5.54106ZM24.9905 4.96461C25.1914 4.98508 25.3743 4.95555 25.5393 4.876C25.7044 4.79646 25.8411 4.66907 25.9497 4.49382C26.0584 4.31699 26.1276 4.09439 26.1575 3.82602C26.1876 3.55605 26.169 3.32369 26.1017 3.12892C26.0344 2.93416 25.9289 2.78126 25.7851 2.67024C25.6413 2.55923 25.469 2.49348 25.2681 2.47301C25.0672 2.45253 24.8835 2.48198 24.7167 2.56135C24.5517 2.6409 24.4149 2.76908 24.3062 2.94591C24.1975 3.12274 24.1281 3.34614 24.098 3.6161C24.0681 3.88447 24.0869 4.11605 24.1542 4.31082C24.2216 4.504 24.3272 4.6561 24.471 4.76712C24.6165 4.8783 24.7896 4.94413 24.9905 4.96461Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 746,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M31.053 3.29053L29.8848 6.68046L29.3092 6.49893L28.4377 3.664L28.4067 3.65425L27.6109 5.96348L26.9688 5.761L28.137 2.37109L28.7125 2.55258L29.5841 5.38752L29.615 5.39727L30.4108 3.08804L31.053 3.29053Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 747,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M30.3828 6.93781L32.1591 3.79883L32.7538 4.10671L31.247 6.7696L32.6939 7.5188L32.4245 7.99487L30.3828 6.93781Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 748,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M34.6432 5.1084L35.2469 5.55605L34.9547 7.33982L34.9863 7.36333L36.7195 6.64802L37.3231 7.09568L34.8153 8.06702L33.9621 9.11962L33.4297 8.72482L34.2829 7.67215L34.6432 5.1084Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 749,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M38.9552 8.69727L39.4405 9.34017L37.8974 11.7116L37.9223 11.7446L40.7626 11.0921L41.2537 11.7428L38.2282 13.832L37.8397 13.3173L39.9191 11.8815L39.9015 11.8582L37.2254 12.4828L36.941 12.1061L38.4147 9.88005L38.3942 9.85289L36.3108 11.2915L35.9297 10.7865L38.9552 8.69727Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 750,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M38.3672 14.2352L41.7787 12.7891L42.763 14.9134L42.2455 15.1328L41.5353 13.5997L40.6194 13.9879L41.2769 15.4071L40.7663 15.6236L40.1088 14.2044L39.1586 14.6071L39.8729 16.149L39.3555 16.3683L38.3672 14.2352Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 751,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M43.1905 15.9873L43.3614 16.7632L40.9454 18.3322L40.9542 18.372L43.8271 18.8775L44.0001 19.6628L40.3487 20.3987L40.2119 19.7775L42.7213 19.2718L42.7151 19.2436L40.0042 18.7765L39.904 18.3218L42.1949 16.8588L42.1877 16.8259L39.6733 17.3326L39.5391 16.7232L43.1905 15.9873Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 752,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M40.3078 20.8242L44.0392 20.8499L44.029 22.22C44.027 22.4772 43.9829 22.6909 43.8964 22.8612C43.8117 23.0314 43.6955 23.1584 43.548 23.2421C43.4021 23.3257 43.2373 23.3669 43.0537 23.3656C42.9017 23.3646 42.7717 23.3357 42.6636 23.2791C42.5571 23.224 42.4709 23.1492 42.4048 23.0545C42.3388 22.9599 42.2911 22.8541 42.2619 22.7373L42.2244 22.7371C42.2184 22.8648 42.1774 22.9859 42.1015 23.1003C42.0271 23.2164 41.9228 23.3107 41.7887 23.3833C41.6546 23.4574 41.4932 23.4938 41.3045 23.4926C41.1109 23.4912 40.9376 23.4453 40.7847 23.3548C40.6334 23.266 40.5133 23.131 40.4246 22.9499C40.3374 22.7704 40.2949 22.5442 40.2969 22.2711L40.3078 20.8242ZM40.8664 21.4749L40.8612 22.1696C40.8595 22.4043 40.9057 22.5739 41.0002 22.6784C41.0945 22.7844 41.2152 22.838 41.3621 22.839C41.474 22.8397 41.5743 22.8141 41.6632 22.762C41.7521 22.7099 41.8228 22.6353 41.8753 22.5383C41.9277 22.4428 41.9545 22.3296 41.9554 22.1986L41.9608 21.4824L40.8664 21.4749ZM42.4467 21.4857L42.4419 22.1277C42.441 22.2379 42.462 22.3379 42.5047 22.4276C42.5475 22.5173 42.6079 22.588 42.6859 22.6397C42.7657 22.6929 42.8598 22.7199 42.9684 22.7206C43.1119 22.7216 43.2308 22.6737 43.3251 22.5769C43.4209 22.4802 43.4696 22.3376 43.471 22.1491L43.4759 21.4928L42.4467 21.4857Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 753,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M40.2294 23.8018L43.9018 24.4347L43.4711 26.7215L42.9141 26.6255L43.2249 24.9752L42.239 24.8053L41.9513 26.333L41.4017 26.2383L41.6894 24.7105L40.6665 24.5343L40.3539 26.194L39.7969 26.0981L40.2294 23.8018Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 754,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M39.6961 26.4639L43.2018 27.6869L42.7221 28.9449C42.6238 29.203 42.4943 29.4026 42.3338 29.5438C42.1728 29.6866 41.9904 29.7734 41.7867 29.8043C41.5845 29.8357 41.372 29.8126 41.1493 29.7349C40.925 29.6567 40.7479 29.5431 40.6182 29.3941C40.4878 29.2466 40.4117 29.0687 40.3897 28.8605C40.3679 28.6523 40.4061 28.4192 40.5045 28.1611L40.8452 27.2676L41.3699 27.4507L41.0609 28.2608C41.0032 28.4124 40.9779 28.5438 40.9852 28.6552C40.9919 28.768 41.0291 28.8617 41.0966 28.9363C41.1652 29.0128 41.2614 29.0728 41.3853 29.116C41.5092 29.1592 41.624 29.1729 41.7295 29.157C41.8367 29.1418 41.9313 29.094 42.0134 29.0139C42.0971 28.9343 42.1681 28.8179 42.2264 28.6649L42.4384 28.109L39.4644 27.0715L39.6961 26.4639ZM38.9779 28.3476L40.8782 28.09L40.6258 28.7516L38.7188 29.0272L38.9779 28.3476Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 755,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M37.0744 31.4675C37.262 31.2131 37.4931 31.026 37.7674 30.9062C38.0407 30.7878 38.3374 30.7486 38.6573 30.7886C38.9763 30.8299 39.2994 30.9611 39.6268 31.1821C39.9555 31.404 40.1937 31.6518 40.3413 31.9253C40.4893 32.2011 40.5507 32.4821 40.5257 32.7681C40.4996 33.0555 40.3927 33.3263 40.205 33.5808C40.0163 33.8366 39.7858 34.023 39.5134 34.1402C39.241 34.2573 38.9442 34.2953 38.6229 34.2544C38.303 34.2144 37.9786 34.0835 37.6499 33.8615C37.3225 33.6405 37.0855 33.3926 36.9389 33.1177C36.7922 32.8428 36.731 32.5629 36.7551 32.2782C36.7792 31.9935 36.8857 31.7232 37.0744 31.4675ZM37.5695 31.8017C37.453 31.9596 37.391 32.1269 37.3833 32.3035C37.3756 32.4801 37.4253 32.6563 37.5326 32.8323C37.6411 33.0092 37.8107 33.1755 38.0413 33.3311C38.2731 33.4876 38.4944 33.5852 38.7051 33.6238C38.9157 33.6624 39.1066 33.6486 39.278 33.5825C39.4494 33.5164 39.5933 33.4044 39.7098 33.2465C39.8263 33.0887 39.8889 32.9208 39.8975 32.7428C39.9052 32.5663 39.8547 32.3895 39.7462 32.2126C39.6376 32.0358 39.4673 31.869 39.2354 31.7125C39.0049 31.5568 38.7843 31.4597 38.5737 31.4212C38.3645 31.3836 38.1741 31.3978 38.0028 31.4638C37.8304 31.5313 37.686 31.6439 37.5695 31.8017Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 756,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M36.1571 37.685L33.625 35.0632L34.0702 34.6698L37.0847 35.3163L37.1086 35.2952L35.3836 33.5092L35.8804 33.0703L38.4125 35.6921L37.9673 36.0855L34.9528 35.439L34.9289 35.4601L36.6538 37.2461L36.1571 37.685Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 757,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M33.1425 35.3584L35.155 38.3641L34.5856 38.713L32.8783 36.1631L31.4927 37.0119L31.1875 36.556L33.1425 35.3584Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 758,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M32.7443 39.81L32.0424 40.0981L30.5528 38.9891L30.516 39.0042L30.3302 40.801L29.6282 41.0891L29.9554 38.5201L29.4062 37.2961L30.0253 37.042L30.5745 38.2659L32.7443 39.81Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 759,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M27.3742 41.6758L26.551 41.7683L25.1365 39.3246L25.0942 39.3293L24.3073 42.0201L23.4741 42.1137L23.0391 38.5687L23.6982 38.4947L23.9972 40.931L24.0271 40.9277L24.7593 38.3876L25.2418 38.3334L26.5573 40.6484L26.592 40.6445L26.2925 38.2035L26.9392 38.1309L27.3742 41.6758Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 760,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M22.5695 38.4865L22.2318 42.0412L19.8125 41.8309L19.8638 41.2918L21.6097 41.4435L21.7003 40.4892L20.084 40.3487L20.1346 39.8167L21.7508 39.9572L21.8448 38.9671L20.089 38.8145L20.1402 38.2754L22.5695 38.4865Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 761,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M18.6356 41.6696L17.8434 41.4361L17.5813 38.6541L17.5406 38.6421L15.6846 40.7997L14.8828 40.5633L15.9818 37.1523L16.616 37.3393L15.8608 39.6835L15.8895 39.692L17.6319 37.6512L18.0962 37.7881L18.322 40.4141L18.3555 40.4239L19.1122 38.0751L19.7345 38.2586L18.6356 41.6696Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 762,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M15.6217 36.9207L13.7818 40.0259L12.5355 39.3504C12.3016 39.2236 12.128 39.0826 12.0145 38.9275C11.9003 38.7738 11.8409 38.6149 11.8364 38.4509C11.831 38.2883 11.8736 38.1306 11.9641 37.9777C12.0391 37.8513 12.1288 37.7567 12.233 37.6939C12.3352 37.6318 12.4455 37.5962 12.5641 37.5871C12.6827 37.578 12.8025 37.5897 12.9234 37.6221L12.9419 37.5909C12.8282 37.5237 12.7375 37.4305 12.67 37.3113C12.6002 37.1927 12.5648 37.0597 12.5638 36.9123C12.5614 36.7641 12.6067 36.6115 12.6997 36.4545C12.7952 36.2934 12.9215 36.1709 13.0786 36.0872C13.2334 36.0041 13.4151 35.9695 13.6237 35.9835C13.83 35.998 14.0574 36.0726 14.3057 36.2073L15.6217 36.9207ZM14.7556 37.0707L14.1238 36.7281C13.9103 36.6124 13.7328 36.5686 13.5915 36.5965C13.4487 36.6238 13.3411 36.6985 13.2686 36.8208C13.2135 36.9139 13.1881 37.0103 13.1923 37.1099C13.1966 37.2094 13.2303 37.3049 13.2934 37.3959C13.355 37.4863 13.4454 37.5637 13.5645 37.6283L14.216 37.9815L14.7556 37.0707ZM13.9764 38.3858L13.3925 38.0692C13.2923 38.0149 13.1908 37.9837 13.0881 37.9757C12.9853 37.9678 12.8914 37.9838 12.8061 38.0239C12.7187 38.0646 12.6482 38.1301 12.5947 38.2204C12.5239 38.3399 12.5098 38.4626 12.5523 38.5885C12.5939 38.7157 12.7005 38.8258 12.8719 38.9187L13.4689 39.2423L13.9764 38.3858Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 763,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M12.9556 35.4093L10.5892 38.1691L8.71094 36.6956L9.06987 36.277L10.4254 37.3404L11.0606 36.5995L9.8058 35.6151L10.16 35.202L11.4148 36.1864L12.0739 35.4178L10.7106 34.3483L11.0696 33.9297L12.9556 35.4093Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 764,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M10.7848 33.6582L7.96669 35.9978L7.04906 34.9865C6.86079 34.7791 6.74106 34.574 6.68973 34.3713C6.63736 34.1674 6.64643 33.9727 6.71694 33.7873C6.7862 33.6029 6.91034 33.4364 7.08934 33.2878C7.26966 33.1381 7.45944 33.0451 7.65856 33.0087C7.85662 32.9711 8.05613 32.9937 8.25715 33.0764C8.45817 33.159 8.65282 33.304 8.84102 33.5115L9.49278 34.2297L9.07096 34.5799L8.47999 33.9286C8.36946 33.8068 8.26155 33.7219 8.15621 33.6741C8.04976 33.625 7.94606 33.6106 7.84512 33.631C7.74188 33.6511 7.64042 33.7026 7.5408 33.7853C7.44118 33.868 7.37303 33.9573 7.33636 34.0534C7.29844 34.1504 7.29621 34.2527 7.32966 34.3602C7.36186 34.4688 7.43382 34.5846 7.5454 34.7077L7.95092 35.1546L10.3415 33.1698L10.7848 33.6582ZM9.41076 32.144L8.72484 33.8586L8.24223 33.3267L8.91502 31.5977L9.41076 32.144Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 765,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M7.47492 29.0421C7.61673 29.3224 7.67607 29.6063 7.65281 29.8939C7.62882 30.18 7.52105 30.4472 7.32956 30.6956C7.13735 30.9425 6.86089 31.1495 6.50022 31.3165C6.13806 31.4842 5.79611 31.5636 5.47439 31.5547C5.15044 31.545 4.8637 31.4604 4.61419 31.3009C4.36395 31.14 4.1679 30.9194 4.02603 30.6391C3.88344 30.3573 3.82451 30.0742 3.84923 29.7895C3.87394 29.5048 3.9828 29.2379 4.17581 28.9888C4.36731 28.7405 4.64414 28.5325 5.0063 28.3648C5.36697 28.1978 5.70853 28.1194 6.03097 28.1298C6.35343 28.1402 6.63903 28.2244 6.88783 28.3824C7.13662 28.5405 7.33232 28.7603 7.47492 29.0421ZM6.92936 29.2947C6.84137 29.1208 6.71842 28.9878 6.56061 28.8959C6.40279 28.804 6.21744 28.7603 6.00456 28.7648C5.79018 28.77 5.556 28.8315 5.30203 28.949C5.04656 29.0673 4.85019 29.2053 4.71293 29.3629C4.57566 29.5205 4.49577 29.687 4.47326 29.8625C4.45076 30.0379 4.48351 30.2126 4.57154 30.3865C4.65957 30.5604 4.78286 30.6941 4.9414 30.7875C5.09923 30.8794 5.28533 30.9227 5.49971 30.9175C5.7141 30.9122 5.94902 30.8505 6.20449 30.7322C6.45847 30.6146 6.65408 30.477 6.79136 30.3194C6.92713 30.1625 7.00625 29.9963 7.02879 29.8209C7.05054 29.644 7.01742 29.4686 6.92936 29.2947Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 766,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M2.24219 25.255L5.86871 24.4141L6.0115 24.9774L3.9547 27.1823L3.96237 27.2125L6.43279 26.6397L6.59211 27.2683L2.96558 28.1092L2.82279 27.5459L4.87958 25.341L4.87192 25.3107L2.4015 25.8836L2.24219 25.255Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 767,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M5.82845 23.8727L2.10387 24.0911L2.0625 23.4456L5.22213 23.2603L5.12145 21.6894L5.68638 21.6562L5.82845 23.8727Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 768,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M1.96094 21.3497L2.03884 20.6229L3.7761 19.9167L3.78019 19.8786L2.22887 18.8499L2.30678 18.123L4.49501 19.6453L5.88019 19.7811L5.81149 20.4221L4.42629 20.2863L1.96094 21.3497Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 769,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M2.85938 15.9547L3.17499 15.2215L6.09518 15.2265L6.11139 15.1889L4.03509 13.2235L4.35452 12.4814L7.80504 13.8404L7.55231 14.4274L5.18099 13.4934L5.16954 13.52L7.13456 15.3665L6.94958 15.7962L4.19516 15.7709L4.18182 15.802L6.55779 16.7378L6.30987 17.3137L2.85938 15.9547Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 770,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M8.08985 13.5183L5.00781 11.5061L6.37734 9.58691L6.84482 9.89209L5.8565 11.2771L6.68389 11.8173L7.59883 10.5352L8.06008 10.8364L7.14514 12.1185L8.00356 12.6789L8.99756 11.286L9.46505 11.5912L8.08985 13.5183Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 771,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M7.09375 8.68528L7.69175 8.13616L10.3617 9.26747L10.3924 9.23924L9.32133 6.63972L9.92656 6.08398L12.5108 8.65882L12.032 9.09844L10.256 7.32889L10.2343 7.34881L11.2537 9.79653L10.9033 10.1184L8.39351 9.03257L8.36821 9.05576L10.1478 10.8288L9.67803 11.2601L7.09375 8.68528Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 772,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M12.9121 8.4614L10.9609 5.4189L12.182 4.70243C12.4111 4.56799 12.6241 4.49081 12.8209 4.47089C13.0168 4.4496 13.191 4.47673 13.3431 4.55226C13.4946 4.62644 13.6183 4.7384 13.7143 4.88814C13.7937 5.01202 13.8369 5.13282 13.8439 5.25053C13.8513 5.36604 13.8305 5.47566 13.7815 5.57938C13.7324 5.6831 13.6638 5.77769 13.5757 5.86315L13.5953 5.89378C13.7118 5.83106 13.8409 5.80027 13.9827 5.8014C14.1249 5.80034 14.2637 5.83506 14.3991 5.90555C14.5358 5.97521 14.6535 6.08695 14.7521 6.24077C14.8534 6.39868 14.9044 6.56361 14.905 6.73565C14.9062 6.90543 14.8499 7.07427 14.7362 7.24216C14.6231 7.40785 14.4448 7.56204 14.2015 7.70485L12.9121 8.4614ZM13.1938 7.6638L13.8129 7.30055C14.0221 7.17779 14.1481 7.05044 14.1909 6.91857C14.235 6.78588 14.2187 6.65966 14.1418 6.53985C14.0834 6.44865 14.0075 6.38076 13.9143 6.33613C13.821 6.29157 13.7175 6.27363 13.6036 6.28237C13.4911 6.29025 13.3766 6.32846 13.2599 6.39692L12.6216 6.77142L13.1938 7.6638ZM12.3676 6.37529L12.9397 6.03962C13.0378 5.982 13.1154 5.91211 13.1724 5.82996C13.2295 5.7478 13.2602 5.66137 13.2647 5.57067C13.2697 5.47777 13.2439 5.38708 13.1872 5.29859C13.1121 5.18152 13.0067 5.11034 12.871 5.08504C12.7344 5.05839 12.5822 5.09433 12.4143 5.19286L11.8294 5.53607L12.3676 6.37529Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 773,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M15.5875 6.95208L14.2109 3.6345L16.4689 2.77734L16.6777 3.28055L15.0482 3.89912L15.4178 4.78975L16.9262 4.21713L17.1322 4.71366L15.6238 5.28627L16.0072 6.2103L17.646 5.5882L17.8547 6.09141L15.5875 6.95208Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 774,
                      columnNumber: 17
                    }, this), u("path", {
                      d: "M18.2404 5.98592L17.4766 2.49217L18.8469 2.21808C19.128 2.16186 19.3735 2.16168 19.5836 2.21756C19.7954 2.27311 19.9687 2.37548 20.1036 2.5247C20.2383 2.67235 20.3298 2.85716 20.3784 3.07914C20.4273 3.30268 20.4198 3.50648 20.356 3.69056C20.2938 3.87431 20.176 4.03002 20.0027 4.15769C19.8293 4.28537 19.6021 4.37731 19.321 4.43353L18.3478 4.62819L18.2335 4.10529L19.1159 3.92878C19.281 3.89577 19.4111 3.84692 19.5061 3.78223C19.6027 3.71721 19.6664 3.63759 19.6969 3.54338C19.7288 3.44727 19.7312 3.33747 19.7042 3.21397C19.6773 3.09048 19.6288 2.99003 19.559 2.91262C19.4889 2.83366 19.3966 2.78196 19.2821 2.75755C19.1673 2.73158 19.0264 2.73526 18.8598 2.7686L18.2543 2.88971L18.9022 5.85353L18.2404 5.98592ZM20.2922 5.57553L19.0607 4.16745L19.7814 4.02329L21.0324 5.42746L20.2922 5.57553Z",
                      fill: "white"
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 775,
                      columnNumber: 17
                    }, this), u("mask", {
                      id: "mask0_13982_689823",
                      style: "mask-type:luminance",
                      maskUnits: "userSpaceOnUse",
                      x: "10",
                      y: "15",
                      width: "28",
                      height: "13",
                      children: u("path", {
                        d: "M37.4585 15.7109H10.5156V27.0252H37.4585V15.7109Z",
                        fill: "white"
                      }, void 0, false, {
                        fileName: _jsxFileName$1,
                        lineNumber: 777,
                        columnNumber: 17
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 776,
                      columnNumber: 17
                    }, this), u("g", {
                      mask: "url(#mask0_13982_689823)",
                      children: [u("path", {
                        d: "M34.6826 20.2469C34.6826 20.4538 34.8574 20.6215 35.073 20.6215H37.0129C37.2286 20.6215 37.4034 20.7893 37.4034 20.9961V22.0603C37.4034 22.2672 37.2286 22.4349 37.0129 22.4349H35.073C34.8574 22.4349 34.6826 22.6027 34.6826 22.8096V25.0018C34.6826 25.2086 34.5078 25.3764 34.2921 25.3764H33.103C32.8874 25.3764 32.7126 25.2086 32.7126 25.0018V22.8096C32.7126 22.6027 32.5378 22.4349 32.3221 22.4349H30.3748C30.1592 22.4349 29.9844 22.2672 29.9844 22.0603V20.9961C29.9844 20.7893 30.1592 20.6215 30.3748 20.6215H32.3221C32.5378 20.6215 32.7126 20.4538 32.7126 20.2469V18.1832C32.7126 17.9763 32.8874 17.8086 33.103 17.8086H34.2921C34.5078 17.8086 34.6826 17.9763 34.6826 18.1832V20.2469Z",
                        fill: "white"
                      }, void 0, false, {
                        fileName: _jsxFileName$1,
                        lineNumber: 780,
                        columnNumber: 17
                      }, this), u("path", {
                        d: "M16.3664 17.85C18.6301 17.764 19.6455 19.8903 19.5722 21.5037C19.5573 21.8303 19.5373 22.1567 19.5406 22.4832C19.549 23.517 19.5606 24.5506 19.5906 25.5843C19.5972 25.8407 19.6304 26.0956 19.6655 26.3488C19.7153 26.7151 19.5972 26.8999 19.1861 26.868C18.5386 26.8187 17.8844 26.8075 17.2419 26.7215C17.0888 26.7008 16.9074 26.4746 16.8424 26.3074C16.6444 25.7977 16.5778 25.7659 16.205 26.1418C15.381 26.97 14.3474 27.134 13.2288 26.9652C12.7911 26.8983 12.3683 26.7454 11.9406 26.6244C10.7737 26.2931 10.4109 25.1893 10.5773 24.1939C10.8753 22.4227 11.9772 21.8955 13.9329 21.6964C14.5621 21.6327 15.1963 21.5897 15.8138 21.4671C16.1034 21.4097 16.5528 21.2377 16.5828 21.0386C16.6394 20.6675 16.4313 20.2072 16.1634 19.9508C15.5292 19.3424 14.3008 19.5622 13.9312 20.3394C13.7082 20.8077 13.422 20.8173 12.9342 20.8635C12.4466 20.9097 12.0071 20.8873 11.5461 20.9319C10.9868 20.9861 10.8087 20.8125 10.9552 20.3172C11.3996 18.812 12.4915 17.9727 14.1376 17.8707C14.6037 17.842 15.0731 17.8245 15.5391 17.8086C15.8205 17.8165 16.0851 17.8596 16.3648 17.85H16.3664ZM14.865 25.2371C15.9537 25.2308 16.8524 24.2878 16.7309 23.2939C16.6927 22.9786 16.5295 22.77 16.1966 22.8273C15.5958 22.9308 14.9915 23.0471 14.414 23.2334C13.7997 23.4325 13.4419 23.9948 13.5485 24.4423C13.65 24.8724 14.2609 25.2418 14.8634 25.2371H14.865Z",
                        fill: "white"
                      }, void 0, false, {
                        fileName: _jsxFileName$1,
                        lineNumber: 781,
                        columnNumber: 17
                      }, this), u("path", {
                        d: "M28.3842 20.5856C28.3723 20.2382 28.0608 20.2614 27.5696 20.2499C26.6233 20.2267 26.3837 20.1919 25.4373 20.1803C23.9996 20.1572 24.0116 20.2382 24.0475 18.8256C24.0475 18.3509 24.2752 18.1772 24.7184 18.1888C25.3654 18.1888 26.0123 18.2004 26.6711 18.212C27.2701 18.2235 27.8572 18.293 28.4562 18.2583C28.6358 18.2583 28.9354 18.1077 28.9594 17.853C29.0072 17.3435 29.0192 16.8225 29.0431 16.313C29.0552 15.9425 28.8396 15.8152 28.4921 15.8036C26.0721 15.7688 23.6642 15.7573 21.2563 15.7109C20.813 15.7109 20.6573 15.8615 20.6453 16.2667C20.6453 17.4014 20.6094 18.5362 20.6094 19.6709C20.6094 21.8709 20.6333 24.0824 20.6094 26.2824C20.6094 26.7686 20.849 26.9077 21.2803 26.9308C21.9511 26.9655 22.61 26.9886 23.2809 27.0234C23.8798 27.0466 24.0836 26.8497 24.0715 26.2708C24.0596 25.275 24.0596 24.2792 24.0356 23.2835C24.0356 22.8319 24.2512 22.6119 24.6945 22.6119C25.3773 22.6119 26.0721 22.6698 26.755 22.6467C27.2462 22.635 27.5337 22.6698 27.953 22.6582C28.1208 22.6582 28.2525 22.6698 28.3004 22.2414C28.3364 21.8593 28.3963 21.1182 28.3723 20.574L28.3842 20.5856Z",
                        fill: "white"
                      }, void 0, false, {
                        fileName: _jsxFileName$1,
                        lineNumber: 782,
                        columnNumber: 17
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$1,
                      lineNumber: 779,
                      columnNumber: 17
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$1,
                    lineNumber: 744,
                    columnNumber: 17
                  }, this), u("defs", {
                    children: u("clipPath", {
                      id: "clip0_13982_689823",
                      children: u("rect", {
                        width: "46",
                        height: "44",
                        fill: "white"
                      }, void 0, false, {
                        fileName: _jsxFileName$1,
                        lineNumber: 787,
                        columnNumber: 17
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName$1,
                      lineNumber: 786,
                      columnNumber: 17
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 785,
                    columnNumber: 17
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$1,
                  lineNumber: 743,
                  columnNumber: 17
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 742,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$1,
              lineNumber: 722,
              columnNumber: 15
            }, this), block.settings.products_to_add.length > 0 && u("button", {
              onClick: () => handleAddProducts(block.settings.products_to_add, block.settings.selling_plan_id),
              className: `rs-w-full rs-mt-2 rs-py-3 rs-px-6 rs-rounded-full rs-font-bold rs-text-sm rs-uppercase rs-transition-colors ${colorScheme.button}`,
              children: "Add"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 796,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1,
            lineNumber: 721,
            columnNumber: 13
          }, this)
        }, block.id, false, {
          fileName: _jsxFileName$1,
          lineNumber: 717,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 692,
        columnNumber: 9
      }, this);
    })
  }, void 0, false, {
    fileName: _jsxFileName$1,
    lineNumber: 686,
    columnNumber: 5
  }, this);
}
var _jsxFileName = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/entrypoints/cart-membership-upsell.tsx";
class CartMembershipUpsellElement extends HTMLElement {
  constructor() {
    super(...arguments);
    this.initialized = false;
  }
  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      const useGlobalSettings = this.getAttribute("data-use-global-settings") === "true";
      const className = this.getAttribute("class") || "";
      let blocks = "[]";
      if (useGlobalSettings) {
        const waitForSettings = () => {
          var _a;
          if ((_a = window.cartMembershipUpsellSettings) == null ? void 0 : _a.blocks) {
            blocks = JSON.stringify(window.cartMembershipUpsellSettings.blocks);
            const textureUrls = window.cartMembershipUpsellSettings.textureUrls || {};
            G(u(CartMembershipUpsell, {
              blocks,
              class: className,
              "blue-texture-desktop": textureUrls.blueTextureDesktop || "",
              "blue-texture-mobile": textureUrls.blueTextureMobile || "",
              "green-texture-desktop": textureUrls.greenTextureDesktop || "",
              "green-texture-mobile": textureUrls.greenTextureMobile || "",
              "purple-texture-desktop": textureUrls.purpleTextureDesktop || "",
              "purple-texture-mobile": textureUrls.purpleTextureMobile || ""
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 53,
              columnNumber: 15
            }, this), this);
          } else {
            setTimeout(waitForSettings, 100);
          }
        };
        waitForSettings();
      } else {
        blocks = this.getAttribute("data-blocks") || "[]";
        G(u(CartMembershipUpsell, {
          blocks,
          class: className,
          "blue-texture-desktop": "",
          "blue-texture-mobile": "",
          "green-texture-desktop": "",
          "green-texture-mobile": "",
          "purple-texture-desktop": "",
          "purple-texture-mobile": ""
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 78,
          columnNumber: 11
        }, this), this);
      }
    }
  }
  disconnectedCallback() {
    this.initialized = false;
    G(null, this);
  }
}
const elementName = "cart-membership-upsell";
if (!customElements.get(elementName)) {
  customElements.define(elementName, CartMembershipUpsellElement);
}
